import React from "react";
import {useLocation, useParams} from "react-router-dom";

import DateInput from "../../../formElements/DateInput";
import SelectInput from "../../../formElements/SelectInput";
import RichTextInput from "../../../formElements/RichTextInput";
import MultiFileInput from "../../../formElements/MultiFileInput";

import FormContext from "../../../support/FormContext";
import GenericForm from "../../GenericForm";

import "../../../../buttons/_static/Buttons.css";
import TwoColumnRows from "../../../formElements/TwoColumnRows";
import InstrumentInstallationSection from "./InstrumentInstallationSection";
import {getAppName} from "../../../../Api";
import InternalNote from "../../serviceCase/serviceCaseForm/InternalNote";
import FreeTypeSelectInput from "../../../formElements/FreeTypeSelectInput";
import RegimeCostList from "../../../tableLists/RegimeCostList";

import StringInput from "../../../formElements/StringInput";

function InstallationForm(props) {

    const {id} = useParams()
    const baseUrl = '/installation/installations/'
    const [fileData, setFileData] = React.useState([]);
    const [isSectionAdded, setIsSectionAdded] = React.useState(false)
    const location = useLocation();
    const instrumentId = location.state?.instrumentId || null;
    const initialParams = {instrumentId: instrumentId}

    function customSubmit(data) {
        const formData = new FormData();
        formData.append('data', data);
        fileData.forEach((file, index) => {
            if (file["newFile"] === true) {
                formData.append(`file_${index}`, file["file"]);
                formData.append(`file_${index}_print`, file["print"]);
            }
        });
        return formData
    }

    function parseFromData(data, commonParseFromData) {
        data.Prilohy = []
        data = commonParseFromData(data)
        fileData.forEach((item, index) => {
            if (item.newFile === false) {
                data.Prilohy.push({Priloha: item.file, Subor: item.file, Tlacit: item.print, id: item.id})
            }
        })
        return data
    }

    function parseData(data, commonParseData) {
        let newData = commonParseData(data)
        if (newData.id === null) {
            const appName = getAppName()
            const user = localStorage.getItem(`${appName}_user`)
            const loggedReferent = newData.Referent_options.find((item) => item.username === user)
            if (loggedReferent !== undefined) {
                newData.Referent = loggedReferent
            }
        }
        return newData
    }

    function formContent(data, update, updateCustom) {
        function selectInstrument(event, index,) {
            const newData = {...data}
            let newInstrument = data.Pristroje_options.find(
                (item) => item.SNR === event.target.value.SNR && item.Produkt.Typ === event.target.value.Produkt.Typ)
            newInstrument.Existing = true
            if (index !== undefined) {
                newData.Pristroje[index].Pristroj = newInstrument
            } else {
                setIsSectionAdded(true)
                newData.Pristroje.push({
                    Pristroj: newInstrument
                })
            }
            updateCustom(newData)
        }

        function addInstrument(instrument) {
            const newData = {...data}
            let newInstrument = instrument
            newInstrument.Produkt = data.Produkt_options.find(
                (item) => item.Typ === instrument.Produkt
            )
            newInstrument.Existing = false
            newData.Pristroje.push({
                Pristroj: newInstrument
            })
                        updateCustom(newData)
        }
        function deleteInstrument(index,) {
            const newData = {...data}
            newData.Pristroje.splice(index, 1)
            updateCustom(newData)
        }

        function selectItem(event, itemIndex, newItemTemplate, itemPath, itemName,) {
            // generic function for selecting item from combobox input and handling data modification
            const newData = {...data}
            let newItem = event.target.value
            if (typeof newItem === 'string') {
                // if no item is selected but user typed something, it will return string. In that case create new item object.
                newItem = newItemTemplate
            }
            const pathsArray = itemPath.split('.')
            let fullPath = newData
            pathsArray.forEach(path => {
                fullPath = fullPath[path]
            })
            if (itemIndex !== null) {
                fullPath[itemIndex] = {
                    Cena_Ks: null,
                    Pocet: 1,
                    [itemName]: newItem
                }
            } else {
                if (event.target.value === '') {
                    return
                }
                fullPath.push({
                    Cena_Ks: null,
                    Pocet: 1,
                    [itemName]: newItem
                })
            }
            updateCustom(newData)

        }

        function updateAddress(event,) {
            let selectedAddressId = null
            if (event.target.value !== "") {
                const customerAddresses = getCurrentCustomerAddresses()
                const selectedAddress = customerAddresses.find((item) => formatAddress(item) === event.target.value)
                selectedAddressId = selectedAddress.id
            }
            const newData = {...data}
            newData.Umiestnenie = selectedAddressId
            updateCustom(newData)
        }

        function deleteLink(index,) {
            const newData = {...data}
            newData.Prilohy.splice(index, 1)
            updateCustom(newData)
        }

        function get_place(data) {
            const customerAddresses = getCurrentCustomerAddresses(data)
            if (customerAddresses.length === 0) {
                return ""
            }
            if (data.Umiestnenie === null) {
                return ""
            }
            const selectedAddress = customerAddresses.find((item) => item.id === data.Umiestnenie)
            return formatAddress(selectedAddress)
        }

        function updateCustomer(event,) {
            const newCustomer = event.target.value
            handleCustomerChange(newCustomer)
        }

        function handleCustomerChange(newCustomer) {
            const newData = {...data}
            newData.Zakaznik = newCustomer
            const customerLocations = getCustomerAddresses(newCustomer)
            if (customerLocations.length === 1) {
                newData.Umiestnenie = customerLocations[0].id
            } else {
                newData.Umiestnenie = null
            }
            updateCustom(newData)
        }

        function getPlaceOptions(data) {
            // filters addresses based on selected customer
            if (data.Zakaznik !== null && data.Zakaznik !== "") {
                const customerAddresses = getCurrentCustomerAddresses(data)
                if (customerAddresses.length === 0) {
                    return []
                }
                let newOptions = customerAddresses.map((item) => formatAddress(item))
                newOptions.unshift("")
                return newOptions
            }
            return []
        }

        function formatAddress(address) {
            return `${address.Nazov}; ${address.Mesto}; ${address.Ulica}; ${address.PSC}`
        }

        function getCurrentCustomerAddresses() {
            if (data.Zakaznik === null || data.Zakaznik === "") {
                return []
            }
            return getCustomerAddresses(data.Zakaznik)
        }

        function getCustomerAddresses(customer) {
            if (customer) {
                return data.Firma_Adresa_options.find((item) => item.company === customer).addresses
            }
            return []
        }

        function getCustomerOptions() {
            const options = Object.keys(data.Zakaznik_pristroje_options)
            return options ? ['', ...options] : []
        }

        function selectReferent(event,) {
            const newVal = event.target.value
            const newData = {...data}
            if (newVal === "") {
                newData.Referent = null
            } else {
                newData.Referent = data.Referent_options.find((item) => item.username === newVal)
            }
            updateCustom(newData)
        }

        function changeNewFilePrint(index, value) {
            let updatedFileData = [...fileData]
            updatedFileData[index].print = value
            setFileData(updatedFileData)
        }

        function selectCost(event, pristrojIndex, costIndex,) {
            const addedNew = costIndex === data.Rezijne_Naklady.length
            const newItemTemplate = {
                "id": null,
                "Nazov": event.target.value,
                "Cena": null
            }
            const itemPath = `Rezijne_Naklady`
            const itemName = "Rezijny_Naklad"
            selectItem(event, costIndex, newItemTemplate, itemPath, itemName, addedNew)
        }

        function updateCost(updatedItem, pristrojIndex, itemIndex) {
            const newData = {...data}
            newData.Rezijne_Naklady[itemIndex] = updatedItem
            updateCustom(newData)
        }

        function deleteCost(pristrojIndex, index) {
            // pristojIndex is not used, but it is here to keep the same signature as other delete functions
            // this is a shameful solution, I will keep this comment here as a reminder to the couchpotatedness of it
            const newData = {...data}
            newData.Rezijne_Naklady.splice(index, 1)
            updateCustom(newData)
        }


        return <>
            <FormContext.Provider value={{data: data, isSectionAdded: isSectionAdded}}>
                <label className="form-label">Číslo</label>
                <p value={data.Cislo} disabled={true} style={{"backgroundColor": "#e9ecef"}}
                   className="form-control">{data.Cislo}</p>
                <SelectInput options={['', ...data.Referent_options.map(option => option.username)]}
                             name={'Referent'}
                             label={'Referent'}
                             value={data.Referent ? data.Referent.username : null}
                             onChange={selectReferent}/>
                <TwoColumnRows>
                    <DateInput name={'Datum_Otvorenia'} label={'Dátum Otvorenia'} value={data.Datum_Otvorenia}
                               onChange={update}/>
                    <DateInput name={'Datum_Uzavretia'} label={'Dátum Uzavretia'} value={data.Datum_Uzavretia}
                               onChange={update}/>
                    <DateInput name={'Datum_Instalacie'} label={'Dátum Inštalácie'} value={data.Datum_Instalacie}
                               onChange={update}/>
                    <DateInput name={'Datum_Zaruky'} label={'Dátum Záruky'} value={data.Datum_Zaruky}
                               onChange={update}/>
                    <StringInput name={'Dokumentacia'} label={'Dokumentácia'} value={data.Dokumentacia} onChange={update}/>
                    <FreeTypeSelectInput options={getCustomerOptions()} name={'Zakaznik'} label={'Zákazník'}
                                 value={data.Zakaznik} onChange={updateCustomer}/>
                    <SelectInput options={getPlaceOptions(data)} name={'Umiestnenie'} label={'Umiestnenie'}
                                 value={get_place(data)} onChange={updateAddress}/>
                    <SelectInput options={data.Stav_options} name={'Stav'} label={'Stav Inštalácie'}
                                 value={data.Stav}
                                 onChange={update}/>
                    <StringInput name={'Cislo_Objednavky'} label={'Číslo Objednávky'} value={data.Cislo_Objednavky} onChange={update}/>
                    <StringInput name={'Cislo_Zmluvy'} label={'Číslo Zmluvy'} value={data.Cislo_Zmluvy} onChange={update}/>
                    <StringInput name={'Dodaci_List'} label={'Číslo Dodacieho Listu'} value={data.Dodaci_List} onChange={update}/>
                </TwoColumnRows>
                <InstrumentInstallationSection deleteInstrument={deleteInstrument}
                                               selectInstrument={selectInstrument}
                                               addInstrument={addInstrument}
                                               data={data} update={update}/>
                <RegimeCostList delete={deleteCost} select={selectCost} update={updateCost} data={data}/>
                <RichTextInput name={'Poznamka'} label={'Poznámka'} value={data.Poznamka}
                               onChange={update}/>
                <InternalNote name={'Interna_Poznamka'} label={'Interná Poznámka'}
                               value={data.Interna_Poznamka}
                               onChange={update}/>
                <MultiFileInput fileData={fileData} setFileData={setFileData} data={data}
                                onChange={changeNewFilePrint}/>
            </FormContext.Provider>
        </>
    }

    return (
        <GenericForm label="Inštalácia"
                     labelNew="Pridať inštaláciu"
                     baseUrl={baseUrl}
                     id={id}
                     formContent={formContent}
                     customSubmit={customSubmit}
                     contentType={'multipart/form-data'}
                     parseData={parseData}
                     parseFromData={parseFromData}
                     reloadDataAfterSave={true}
                     reportGeneration={"IP"}
                     reportType="installation"
                     noReportPreview={true}
                     initalParams={initialParams}
        />
    )
}

export default InstallationForm